import { render, staticRenderFns } from "./InfiniteList.vue?vue&type=template&id=3e1381ae&scoped=true&"
import script from "./InfiniteList.vue?vue&type=script&lang=js&"
export * from "./InfiniteList.vue?vue&type=script&lang=js&"
import style0 from "./InfiniteList.vue?vue&type=style&index=0&id=3e1381ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1381ae",
  null
  
)

export default component.exports